import isVisible from "@/util/isVisibleElement";
import specialRuleIds from "@/util/specialRuleIds";

export default ({ config, configList, configTemplate, roles }) => {
    let visibleFields = {};
    const checkConfigState = ({ category, availableFieldList, ruleId, parentVisibility = true }) => {
        for (const field of availableFieldList) {
            const currentRuleId = visibleFields[ruleId] || {};
            const currentCategory = visibleFields[ruleId] && visibleFields[ruleId][category] || {}

            const fieldIsVisible = parentVisibility && isVisible(roles, config[ruleId], field);

            const updatedCategory = { ...currentCategory, [field.FieldId]: fieldIsVisible };
            visibleFields = { ...visibleFields, [ruleId]: { ...currentRuleId, [category]: updatedCategory } };

            const isConfigSet =
                config[ruleId] &&
                config[ruleId][category] &&
                field.FieldId in config[ruleId][category];

            if (field.Options) {
                for (const f of field.Options) {
                    const optionIsVisible = parentVisibility === false ? false : isVisible(roles, config[ruleId], f);

                    const currentRuleId = visibleFields[ruleId] || {};
                    const currentCategory = visibleFields[ruleId] && visibleFields[ruleId][category] || {}

                    const updatedCategory = Object.assign({}, currentCategory, { [f.FieldId]: optionIsVisible });
                    const updatedRuleId = Object.assign({}, currentRuleId, { [category]: updatedCategory });
                    visibleFields = Object.assign({}, visibleFields, { [ruleId]: updatedRuleId });

                    if (optionIsVisible) {
                        // If the Option value matches what is set for the field value, display the Options
                        if (isConfigSet || f.DefaultValue !== undefined || f.Type === 'object') {
                            let valueToCompare;
                            if (isConfigSet) {
                                valueToCompare = config[ruleId][category][field.FieldId];
                            } else {
                                valueToCompare = field.DefaultValue;
                            }
                            let match = f.Value === valueToCompare;
                            if (!match) {
                                // if its not a match, lets make sure its not because a boolean to strig mismatch
                                if (typeof f.Value === "boolean" && typeof valueToCompare === "string") {
                                    match = ((f.Value && valueToCompare === "true") || (!f.Value && valueToCompare === "false"));
                                }
                            }
                            if ((match || f.Type === 'object') && f.AvailableFieldList) {
                                checkConfigState({ category, availableFieldList: f.AvailableFieldList, ruleId, parentVisibility: optionIsVisible });
                            }
                        }
                    }
                }
            }
            if (field.AvailableFieldList) {
                checkConfigState({ category, availableFieldList: field.AvailableFieldList, ruleId, parentVisibility: fieldIsVisible })
            }
        }
    }
    const loadedRuleIds = [...configList.map(client => client.ClientInfoRuleId), ...specialRuleIds];
    for (const ruleId of loadedRuleIds) {
        for (const [category, templateFields] of Object.entries(configTemplate)) {
            if (templateFields.AvailableFieldList) {
                checkConfigState({ category, availableFieldList: templateFields.AvailableFieldList, ruleId });
            }
        }
    }
    return visibleFields;
}